<template>
  <div class="page">
    <a-card title="小程序" :bodyStyle="{paddingTop:'0px'}" :bordered="false"
            :headStyle="{borderBottom:'0px',fontSize:'18px'}">
      <a-tabs defaultActiveKey="1" @change="callback">
        <a-tab-pane tab="微信小程序" key="1">
          <WeChatApplet></WeChatApplet>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
import WeChatApplet from '../component/WeChatApplet'

export default {
  name: 'Applets',
  components: {
    WeChatApplet
  },
  data() {
    return {
      merchantId: this.$store.getters.userInfo.merchantId
    }
  },
  mounted() {

  },
  methods: {
    callback(key) {
      this.getLogUtils().logWithTag('callback', key)
    }
  }

}
</script>
<style lang="less" scoped>
.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}
</style>